/**
 * address Group
 * @param fb : FormBuilder
 */
export function paxtypeGroup (fb: any):any {
    return fb.group({
        id: fb.control(''),
        code: fb.control(''),
        xType: fb.control(''),
        name: fb.control(''),
        isMain: fb.control(''),
        rebate: fb.array([
            fb.control(0)
        ]),
        age: fb.group({
            min: fb.control(''),
            max: fb.control('')
        }),
        stock: fb.group({
            usesStock: fb.control(true)
            // limit: {
            //     max: fb.control(''),
            //     percentage: fb.control('')
            // }
        }),
        ticketInformation: ticketInformationGroup(fb)
    });
}

export function ticketInformationGroup (fb: any):any {
    return fb.group({
            scope: fb.control(''),
            fareBasis: fb.control(''),
            tourCode: fb.control(''),
            luggage: fb.group({
                quantity: fb.control(''),
                weight: fb.control(''),
                unit: fb.control('')
            }),
            travellerType: travellerTypeGroup(fb)
        });
}

export function ticketInformationArrayGroup (fb: any):any {
    return fb.array([ ticketInformationGroup(fb) ]);
}

export function travellerTypeGroup (fb: any):any {
    return fb.group({
        code: fb.control(''),
        name: fb.control(''),
        xType: fb.control('')
    });
}
